import { PspContext } from "@/config/contexts";
import { useContext } from "react";

export function useMfaMethodItem() {
  const { lang } = useContext(PspContext);

  return { lang };
}
